import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {InfoDetail, InfoDetailVisit, InfoDetailLine, InfoDetailLoc} from "./style";

export default class Detail extends Component {
  static propTypes = {
    itemInfo: PropTypes.object,
  };

  static defaultProps = {
    itemInfo: {},
  };

  renderDetailInfo() {
    let now = new Date();
    const {startTime} = this.props.itemInfo;
    const {accessNumber, bidCount} = this.props.realTimeData ? this.props.realTimeData : {}
    if (startTime > now) {
      return <InfoDetailVisit>{accessNumber}次围观</InfoDetailVisit>
    } else {
      return <InfoDetailVisit>{bidCount}次出价</InfoDetailVisit>
    }
  }

  render() {
    const { itemInfo = {}, realTimeData = {} } = this.props || {};
    const { province } = itemInfo;
    const { accessNumber, bidCount } = realTimeData;
    const { listToAuction = 0 } = realTimeData.sysDictValueData || {};
    const isShowDetailInfo =
      typeof accessNumber !== "undefined" &&
      accessNumber !== null &&
      typeof bidCount !== "undefined" &&
      bidCount !== null &&
      !listToAuction;
    return (
      <InfoDetail>
        {isShowDetailInfo && this.renderDetailInfo()}
        {province && province !== '其他' &&
          <React.Fragment>  
            {
              !listToAuction && isShowDetailInfo && (<InfoDetailLine></InfoDetailLine>)
            }
            <InfoDetailLoc>{province}</InfoDetailLoc>
           </React.Fragment>
        }
      </InfoDetail>
    )
  }
}
